import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
const resources = {
    en: {
        translation: {
            "title": "CallGeept.AI",
            "subtitle": "Get personalized advice, tips, and support from AI-powered chatgpt personas, anytime, anywhere.",
            "signUp": "Sign Up",
            "howYourFriendCanHelp": "How CallGeept.AI can help you",
            "programmingHelp": "Programming Help",
            "programmingHelpDesc": "Get assistance with coding problems, learn new programming languages, or debug your code.",
            "careerGuidance": "Career Guidance",
            "careerGuidanceDesc": "Receive personalized advice on career paths, job search strategies, and resume building.",
            "relationshipAdvice": "Relationship Advice",
            "relationshipAdviceDesc": "Talk about your relationships, get advice on communication, and navigate complex emotions.",
            "mentalHealthSupport": "Mental Health Support",
            "mentalHealthSupportDesc": "Discuss stress, anxiety, or other mental health concerns in a safe and non-judgmental environment.",
            "fitnessTips": "Fitness Tips",
            "fitnessTipsDesc": "Get personalized workout routines, nutritional advice, and motivation to reach your fitness goals.",
            "hobbyIdeas": "Hobby Ideas",
            "hobbyIdeasDesc": "Discover new hobbies, learn new skills, or get advice on how to improve your current interests.",
            "howItWorks": "How It Works",
            "step1": "Step 1",
            "step1Desc": "Sign up and securely purchase a calling card.",
            "step2": "Step 2",
            "step2Desc": "Select an \"Friend\" to call and call their number.",
            "step3": "Step 3",
            "step3Desc": "Enter your calling card code and start talking and get personalized advice, tips, and support.",
            "readyToStart": "Ready to start chatting with CallGeept.AI?",
            "readyToStartDesc": "Sign up today and purchase a calling card to unlock a world of personalized advice and support."
        }
    },
    es: {
        translation: {
            "title": "CallGeept.AI",
            "subtitle": "Obtén consejos personalizados, trucos y soporte de personas AI de chatgpt, en cualquier momento y lugar.",
            "signUp": "Registrarse",
            "howYourFriendCanHelp": "Cómo CallGeept.AI puede ayudarte",
            "programmingHelp": "Ayuda en Programación",
            "programmingHelpDesc": "Obtén ayuda con problemas de programación, aprende nuevos lenguajes de programación o depura tu código.",
            "careerGuidance":"Orientación Profesional",
            "careerGuidanceDesc": "Recibe consejos personalizados sobre trayectorias profesionales, estrategias de búsqueda de empleo y creación de currículums.",
            "relationshipAdvice": "Consejos sobre Relaciones",
            "relationshipAdviceDesc": "Habla sobre tus relaciones, recibe consejos sobre comunicación y navega emociones complejas.",
            "mentalHealthSupport": "Apoyo en Salud Mental",
            "mentalHealthSupportDesc": "Habla sobre el estrés, la ansiedad u otras preocupaciones de salud mental en un entorno seguro y sin prejuicios.",
            "fitnessTips": "Consejos de Fitness",
            "fitnessTipsDesc": "Obtén rutinas de entrenamiento personalizadas, consejos sobre nutrición y motivación para alcanzar tus objetivos de fitness.",
            "hobbyIdeas": "Ideas de Pasatiempos",
            "hobbyIdeasDesc": "Descubre nuevos pasatiempos, aprende nuevas habilidades o recibe consejos sobre cómo mejorar tus intereses actuales.",
            "howItWorks": "Cómo Funciona",
            "step1": "Paso 1",
            "step1Desc": "Regístrate y compra de manera segura una tarjeta de llamadas.",
            "step2": "Paso 2",
            "step2Desc": "Selecciona un \"Amigo\" para llamar y marca su número.",
            "step3": "Paso 3",
            "step3Desc": "Introduce el código de tu tarjeta de llamadas y comienza a hablar para recibir consejos, trucos y soporte personalizados.",
            "readyToStart": "¿Listo para comenzar a chatear con CallGeept.AI?",
            "readyToStartDesc": "Regístrate hoy y compra una tarjeta de llamadas para desbloquear un mundo de consejos y soporte personalizados."

        },
    }
}

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next) // make sure you are using the instance and not the module here
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    //backend: {
    //  loadPath: './locales/{{lng}}.json',
   // }
  });

export default i18n;